"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.valueMessages = exports.Value = void 0;
const schema_1 = require("../../../schema");
var Value;
(function (Value) {
    Value["CRT_P"] = "CRT-P";
    Value["CRT_D"] = "CRT-D";
    Value["ICD"] = "ICD";
    Value["VVI"] = "VVI";
    Value["DDD"] = "DDD";
    Value["NO"] = "no";
})(Value || (exports.Value = Value = {}));
exports.valueMessages = {
    [Value.CRT_P]: {
        id: "htx.currentCardiologicalState.pacemakerTherapy.value.CRT_P",
        defaultMessage: "CRT-P"
    },
    [Value.CRT_D]: {
        id: "htx.currentCardiologicalState.pacemakerTherapy.value.CRT_D",
        defaultMessage: "CRT-D"
    },
    [Value.ICD]: {
        id: "htx.currentCardiologicalState.pacemakerTherapy.value.ICD",
        defaultMessage: "ICD"
    },
    [Value.VVI]: {
        id: "htx.currentCardiologicalState.pacemakerTherapy.value.VVI",
        defaultMessage: "VVI"
    },
    [Value.DDD]: {
        id: "htx.currentCardiologicalState.pacemakerTherapy.value.DDD",
        defaultMessage: "DDD"
    },
    [Value.NO]: {
        id: "htx.currentCardiologicalState.pacemakerTherapy.value.NO",
        defaultMessage: "Nincs"
    }
};
const value = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Value.CRT_P),
    schema_1.Schema.singleChoiceItem(Value.CRT_D),
    schema_1.Schema.singleChoiceItem(Value.ICD),
    schema_1.Schema.singleChoiceItem(Value.VVI),
    schema_1.Schema.singleChoiceItem(Value.DDD),
    schema_1.Schema.singleChoiceItem(Value.NO)
])
    .interpretation({ vocab: "htx", code: "pacemaker_therapy" })
    .tag({ vocab: "snomed", code: "307280005" })
    .tag({ vocab: "loinc", code: "58271-8" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
